import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { useSwiperClass } from '../hooks/use-swiper-class'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useShopQuery } from '../generated/graphql'
import { Autoplay, EffectFade } from 'swiper/modules'
import classNames from 'classnames'
import { SvgLeftAngle, SvgRightAngle } from '../components/svg'

const Outer = styled.div`
  margin-top: 2rem;
  @media (max-width: 40rem){
    margin-top: 0.75rem;
  }
`

const Inner = styled.div`

`

const SwiperContainer = styled.div`
  position: relative;
  @media (max-width: 40rem){
    margin-left: calc(var(--side-margin) * -1);
    margin-right: calc(var(--side-margin) * -1);
  }
`

const Image = styled.div`
  img {
    display: block;
    width: 100%;
    height: auto;
  }
`

const Overlay = styled.div`
  display: none;
  position: absolute;
  top: 0.3125rem;
  right: 0.6875rem;
  font-size: 0.75rem;
  line-height: 1.75;
  letter-spacing: 0.02em;
  color: white;
  z-index: 1;
  pointer-events: none;
  @media (max-width: 40rem){
    display: block;
  }
`

const List = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 0.625rem;
  margin-top: 0.6875rem;
  @media (max-width: 40rem){
    display: none;
  }
`

const ListItem = styled.div`
  position: relative;
  &::after {
    content: '';
    display: block;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0.1875rem solid var(--blue);
    box-sizing: border-box;
    opacity: 0;
    transition: opacity 0.4s;
    position: absolute;
  }
  &.active::after {
    opacity: 1;
  }
  img {
    display: block;
    width: 100%;
    height: auto;
  }
`

const Controls = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  z-index: 2;
  box-sizing: border-box;
`

const Button = styled.div`
  pointer-events: all;
  cursor: pointer;
  color: white;
  display: flex;
  align-items: center;
  padding: var(--page-margin);
  &.disabled {
    opacity: 0;
    pointer-events: none;
  }
  svg {
    display: block;
    height: 2.625rem;
    width: auto;
  }
`

type ShopGallerySectionProps = {

}
export const ShopGallerySection: FunctionComponent<ShopGallerySectionProps> = () => {
  const {ref, slideNext, slidePrev, hasNext, hasPrev, slideTo, activeIndex, slideCount} = useSwiperClass()
  const shopQuery = useShopQuery({
    variables: {
      slug: location.pathname.match(/(?<=\/).*$/)?.[0] ?? ''
    }
  })
  const shop = shopQuery.data?.shop
  if(!shop) return null
  return <Outer>
    <Inner>
      <SwiperContainer>
        <Swiper
          onSwiper={ref}
          modules={[
            Autoplay,
            EffectFade
          ]}
          autoplay={{
            delay: 4000
          }}
          effect="fade"
        >
          {
            shop.shopFields?.images?.nodes.map((image, i) => {
              return <SwiperSlide key={i}>
                <Image>
                  <img src={image.mediaItemUrl ?? ''} />
                </Image>
              </SwiperSlide>
            })
          }
        </Swiper>
        <Controls>
          <Button onClick={() => slidePrev()} className={classNames({disabled: !hasPrev})}>
            <SvgLeftAngle />
          </Button>
          <Button onClick={() => slideNext()} className={classNames({disabled: !hasNext})}>
            <SvgRightAngle />
          </Button>
        </Controls>
        <Overlay>{activeIndex + 1} / {slideCount}</Overlay>
      </SwiperContainer>
      <List>
          {
            shop.shopFields?.images?.nodes.map((image, i) => {
              return <ListItem key={i} onClick={() => slideTo(i)} className={classNames({active: activeIndex === i})}>
                <img src={image.mediaItemUrl ?? ''} />
              </ListItem>
            })
          }
      </List>
    </Inner>
  </Outer>
}